import { Box, Container, Button } from '@mui/material';
import React, { FC } from 'react';
import { Typography700 } from 'views/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import { PlanCardList } from 'views/rebranded-module/common/components/UI/PlanCardList';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/HomeViewV2/components/UI/MembershipPlansSection/MembershipPlansSection.styles';
import { ThemeProvider } from '@mui/material/styles';
import theme from 'lib/config/theme';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';

const MembershipPlansSection: FC<any> = (props) => {
  const content = useContent();
  const { plansData } = props;

  return (
    <StyledBox>
      <Container maxWidth="md" className="MPSContainer">
        <Box className="MPSWrapper">
          <Box textAlign="center">
            <Typography700 variant="h2">
              {content.HomePage.membershipPlansHeader}
            </Typography700>
            <Typography500 variant="body1" pt={2}>
              {content.HomePage.membershipPlansSubheader}
            </Typography500>
          </Box>
          <ThemeProvider theme={theme}>
            <PlanCardList
              cardActions={false}
              showRentalWord={false}
              plansData={plansData}
              content={content}
            />
          </ThemeProvider>
          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              component={NavigatorLink}
              className="MPSAction"
              href={PATHS.motorcycleClub.index({
                ref: 'homepage',
              }) as unknown as string}>
              {content.HomePage.membershipPlanAction}
            </Button>
          </Box>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { MembershipPlansSection };
